import { EntityBase } from './EntityBase';
import { Material } from './Material';
import { FSAG } from './FSAG';

import { Validator } from 'breeze-client';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

export class MaterialFSAG extends EntityBase {

   /// <code> Place custom code between <code> tags
   
   /// </code>

   // Generated code. Do not place code below this line.
   sAGID: number;
   materialId: number;
   created: Date;
   createdUser: string;
   modified: Date;
   modifyUser: string;
   rowVersion: number;
   fSAG: FSAG;
   material: Material;
}

